import { immediateToast } from "izitoast-react";
import {
  FileDownloadUrl,
  getFileDownloadUrl,
  getFileTemplateUrl,
  internalGetFileDownloadUrl,
  internalGetFileTemplateUrl
} from "src/network/graphql/bulkUploadService";
import { downloadPresignedUrl } from "./presignedUtils";
import { isUnauthorizedError } from "./errors";

const toastFileLinkError = (error: unknown, fallback: string) => {
  const message = isUnauthorizedError(error) ? "You don't have access to this file." : fallback;

  immediateToast("error", { message, timeout: 3000, position: "topCenter" });
};

// File and template links carry an attachment disposition, so an anchor click downloads without a popup.
const openLink = (link?: FileDownloadUrl | null) => {
  if (!link?.url) throw new Error("File link unavailable");
  downloadPresignedUrl(link.url);
};

// Links live for minutes, so each click asks for a fresh one.
export const openFileDownload = async (fileId: string, internal = false): Promise<void> => {
  try {
    if (internal) {
      const internalResponse = await internalGetFileDownloadUrl(fileId);

      openLink(internalResponse.data?.internal_get_file_download_url);
      return;
    }
    const response = await getFileDownloadUrl(fileId);

    openLink(response.data?.get_file_download_url);
  } catch (error) {
    toastFileLinkError(error, "We couldn't download this file. Please try again.");
  }
};

export const openFileTemplate = async (fileType: string, internal = false): Promise<void> => {
  try {
    if (internal) {
      const internalResponse = await internalGetFileTemplateUrl(fileType);

      openLink(internalResponse.data?.internal_get_file_template_url);
      return;
    }
    const response = await getFileTemplateUrl(fileType);

    openLink(response.data?.get_file_template_url);
  } catch (error) {
    toastFileLinkError(error, "We couldn't download this template. Please try again.");
  }
};
